import { Controller } from '@hotwired/stimulus';

// The phone's dock (fire/shared/_dock, docs/DESIGN.md § The dock), on its nav.
//
// Typing: a keyboard comes up when she touches a text field (or its label),
// never for a focus the page gives (qir's till box, a guide's first field).
// So html[data-fire-typing] is set only when the field with the focus is the
// one she touched; fire.css hides the dock under it, a host's foot bar reads
// it too (gln's Salvar).
//
// Mais, when it opens a popover: popovertarget opens and closes it with no
// script; this writes aria-expanded back from the popover's own toggle (Esc,
// a tap outside).
//
//   <nav data-controller="dock" data-dock-popover-value="user-menu">
//     <button popovertarget="user-menu" data-dock-target="more">
const FIELD =
  "input:not([type='checkbox'], [type='radio'], [type='button'], [type='submit'], [type='reset'], [type='range'], [type='color'], [type='file'], [type='image']), textarea, [contenteditable]";

export default class extends Controller {
  static targets = ['more'];
  static values = { popover: String };

  connect() {
    this.sheet = this.popoverValue ? document.getElementById(this.popoverValue) : null;
    this.sheet?.addEventListener('toggle', this.sync);
    this.sync();
    document.addEventListener('pointerdown', this.touch, true);
    document.addEventListener('focusin', this.type);
    document.addEventListener('focusout', this.rest);
  }

  disconnect() {
    this.sheet?.removeEventListener('toggle', this.sync);
    document.removeEventListener('pointerdown', this.touch, true);
    document.removeEventListener('focusin', this.type);
    document.removeEventListener('focusout', this.rest);
    this.typing(false);
  }

  sync = () => {
    if (this.hasMoreTarget) this.moreTarget.setAttribute('aria-expanded', String(!!this.sheet?.matches(':popover-open')));
  };

  // She touched it: the field itself, inside it, or its label.
  touched(field) {
    const at = this.touchedAt;
    return !!at && (field.contains(at) || at.closest('label')?.control === field);
  }

  touch = (event) => {
    this.touchedAt = event.target;
    const field = document.activeElement;
    if (field?.matches(FIELD) && this.touched(field)) this.typing(true); // the page's focus, then her tap
  };

  type = (event) => this.typing(event.target.matches(FIELD) && this.touched(event.target));

  rest = () => this.typing(false);

  typing(on) {
    document.documentElement.toggleAttribute('data-fire-typing', on);
  }
}
